import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { FolderKanban } from 'lucide-react';
import employeeApi from '../../lib/employeeApi';
import EmployeeLayout from '../../components/EmployeeLayout';

export default function DepartmentsPage() {
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await employeeApi.get('/api/departments');
      setDepartments(res.data);
    } catch (error) {
      toast.error('Failed');
    }
  };

  return (
    <EmployeeLayout>
      <div className="p-8">
        <h1 className="text-2xl font-bold text-navy-900 mb-6">Departments</h1>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {departments.map((dept) => (
            <Link key={dept._id} to={`/employee/departments/${dept.name}`} className="bg-white rounded-xl border border-charcoal-200 p-6 hover:border-pink-500 hover:shadow-lg transition-all">
              <FolderKanban className="w-12 h-12 text-pink-600 mx-auto mb-3" />
              <h3 className="font-semibold text-charcoal-900 text-center">{dept.name}</h3>
              <p className="text-sm text-charcoal-600 mt-1 text-center">{dept.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </EmployeeLayout>
  );
}